import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MapProvider } from 'libraries/interfaces/MapProvider';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { IMapComponent } from './IMapComponent';
import { IPoint, IMarkerPoint } from './IPoint';
import { ISegment } from './ISegment';
import { IMapConfiguration } from 'libraries/interfaces/IMapConfiguration';
import { GoogleMapComponent } from './google/googleMap.component';
import { LeafletMapComponent } from './leaflet/leafletMap.component';
import { IMapBounds, IMinimumBounds, ICenterRadiusBounds } from './IMapBounds';

@Component({
    selector: 'map',
    template: `
        <ng-container [ngSwitch]="configuration?.provider">
            <google-map *ngSwitchCase="mapProvider.GoogleMaps"
                        #googleMap
                        [defaultCenter]="defaultCenter"
                        [defaultBounds]="defaultBounds"
                        [defaultZoom]="defaultZoom"
                        [points]="points"
                        [segments]="segments"
                        [configuration]="configuration"
                        [style.minHeight]="configuration.minHeight"
                        [activateSearch]="activateSearch"
                        [searchText]="searchText"
                        (onMarkerClick)="onMarkerClick.emit($event)"
                        (onBoundsChanged)="onBoundsChanged.emit($event)">
            </google-map>

            <leaflet-map *ngSwitchDefault
                         #leafletMap
                         [defaultCenter]="defaultCenter"
                         [defaultBounds]="defaultBounds"
                         [defaultZoom]="defaultZoom"
                         [points]="points"
                         [segments]="segments"
                         [style.minHeight]="configuration.minHeight"
                         [configuration]="configuration"
                         [activateSearch]="activateSearch"
                         [searchText]="searchText"
                         (onMarkerClick)="onMarkerClick.emit($event)"
                         (onBoundsChanged)="onBoundsChanged.emit($event)">
            </leaflet-map>
        </ng-container>
    `,
    styles: [`
        :host {
            display: block;
            position: relative;
        }

        leaflet-map,
        google-map {
            width: 100%;
            height: 100%;
        }

    `]
})
export class MapComponent implements IMapComponent {
    @Input()
    public defaultCenter: IPoint;

    @Input()
    public defaultBounds: IMinimumBounds | ICenterRadiusBounds;

    @Input()
    public points: IMarkerPoint[];

    @Input()
    public segments: ISegment[];

    @Input()
    public configuration: IMapConfiguration;

    @Input()
    public activateSearch: boolean;

    @Input()
    public defaultZoom: number = 5;

    @Input()
    public searchText: string;
    @Input()
    public minHeight: string;

    @Output()
    public readonly onMarkerClick: EventEmitter<IMarkerPoint> = new EventEmitter();

    @Output()
    public readonly onBoundsChanged: EventEmitter<IMapBounds> = new EventEmitter();

    @ViewChild('googleMap')
    public googleMap: GoogleMapComponent;

    @ViewChild('leafletMap')
    public leafletMap: LeafletMapComponent;

    public readonly mapProvider: typeof MapProvider = MapProvider;

    public readonly labels: ILabels = {
        unknownProvider: Yii.t("wui-shared-js", "Fournisseur de carte inconnu")
    };

    public invalidateSize(): void {
        if (this.leafletMap) {
            this.leafletMap.invalidateSize();
        }
        if (this.googleMap) {
            this.googleMap.invalidateSize();
        }
    }
}
